export default {"src":"/_next/static/media/bank_icon.6b770490.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};